export default "__VITE_ASSET__BkAVs6q9__"